import { useProcedureContext } from 'client/components/schema/procedures/context/ProcedureContext';
import { useRequestCompileContext } from 'client/components/schema/requests/compile-context/RequestCompileContext';

/**
 * Ottiene la `Procedure` corrente, a prescindere che sia lato frontend, quindi
 * compilazione lato cittadino, sia lato backend.
 */
export function useSharedProcedure() {
  const request = useRequestCompileContext();
  const procedure = useProcedureContext();
  if (request?.procedure) return request.procedure;
  return procedure.procedureFormik.values;
}
